import React from 'react';
import FormInput from 'components/FormInput';
import FileInput from 'components/FileInput';

const ProjectStep = () => (
  <>
    <FormInput
      label='Klus in 30 tekens *'
      id='title'
      placeholder='Lamp ophangen'
    />
    <FormInput
      label='Omschrijving *'
      id='description'
      placeholder='Omschrijving van de klus'
      type='textarea'
      rows={10}
    />
    <FileInput id='images' label='Afbeeldingen uploaden' />
  </>
);

export default ProjectStep;
